export const VK_ERROR_CODES = {
  BLOCK_USER: 15,
  STOP_ADVANCED_STAT_COLLECT: 10,
};
